import { ROUTE_ABANDONED_PAGE, ROUTE_ERROR_PAGE, ROUTE_GENERIC_PAGE, ROUTE_INSTA_EDUCATION_PAGE, ROUTE_SUCCESS_PAGE } from "../Routes/RouteMapping";
import {
  CONNECTED_ACCOUNT_ID,
  CONNECTED_STORAGE_WORK_PLATFORM_ID,
  CONNECTED_USER_ID,
  CONNECTION_ABANDONED,
  CONNECTION_ERROR,
  CONNECTION_SUCCESS,
  INSTAGRAM_WORK_PLATFORM_ID,
  PRODUCTION_ENVIRONMENT,
  STAGING_ENVIRONMENT,
  STORAGE_AUTH_DATA,
  STORAGE_AUTH_SDK_TOKEN,
  STORAGE_AUTH_TENANT_APP_NAME,
  STORAGE_AUTH_USER_ID,
  STORAGE_CONNECTION_STATE,
  STORAGE_CREATOR_ENVIRONMENT,
  STORAGE_WORK_PLATFORM_ID,
} from "./constants";

export const navigateToPlatformEducationPage = (navigate) => {
  const platform = sessionStorage.getItem(STORAGE_WORK_PLATFORM_ID);
  if (platform === INSTAGRAM_WORK_PLATFORM_ID) {
    navigate(ROUTE_INSTA_EDUCATION_PAGE);
  } else {
    navigate(ROUTE_GENERIC_PAGE);
  }
};

export const launchSDK = async (setLoader, navigate, id) => {
  setLoader(true);
  let env;
  try {
    // const environment = process.env.REACT_APP_SDK_ENVIRONMENT;
    const environment = sessionStorage.getItem(STORAGE_CREATOR_ENVIRONMENT).toLowerCase();
    if (environment === STAGING_ENVIRONMENT) env = process.env.REACT_APP_SDK_ENVIRONMENT_STAGING;
    else if (environment === PRODUCTION_ENVIRONMENT) env = process.env.REACT_APP_SDK_ENVIRONMENT_PRODUCTION;
    const auth = JSON.parse(sessionStorage.getItem(STORAGE_AUTH_DATA));
    const clientDisplayName = auth[STORAGE_AUTH_TENANT_APP_NAME];
    let workPlatformId;
    //clear connection state
    sessionStorage.removeItem(STORAGE_CONNECTION_STATE);

    // if id not passed get from storage
    if (id === undefined) {
      workPlatformId =
        sessionStorage.getItem(STORAGE_WORK_PLATFORM_ID) !== "undefined" && sessionStorage.getItem(STORAGE_WORK_PLATFORM_ID) !== "null"
          ? sessionStorage.getItem(STORAGE_WORK_PLATFORM_ID)
          : null;
    } else {
      workPlatformId = id;
    }
    const userId = auth[STORAGE_AUTH_USER_ID];
    let token = auth[STORAGE_AUTH_SDK_TOKEN];

    //   if (!userId || !token) {
    //     const timeStamp = new Date();
    //     const userId = await createUser(clientDisplayName, timeStamp.getTime());

    //     const token = await createUserToken(userId);
    //     sessionStorage.setItem("PhylloUserId", userId);
    //     sessionStorage.setItem("PhylloToken", token);
    //   }
    // const phylloConnectURL = await window.PhylloConnectSDK.clientConnect(
    //   env,
    //   userId,
    //   token,
    //   name,
    //   workPlatformId
    // );
    // window.location.href = phylloConnectURL;

    const config = {
      clientDisplayName,
      environment: env,
      userId,
      token,
      redirect: false,
      workPlatformId,
    };
    const onExitCallBack = (reason, userId) => {
      console.log(`onExit reason: ${reason}, userId: ${userId}`);
      //check state
      const state = sessionStorage.getItem(STORAGE_CONNECTION_STATE);
      if (state === CONNECTION_SUCCESS) {
        navigate(ROUTE_SUCCESS_PAGE);
        setLoader(false);
        return;
      } else if (state === CONNECTION_ABANDONED) {
        navigate(ROUTE_ABANDONED_PAGE);
        setLoader(false);
        return;
      } else if (state === CONNECTION_ERROR) {
        navigate(ROUTE_ERROR_PAGE);
        setLoader(false);
        return;
      } else {
        if (reason === "BACK_PRESSED") {
          setLoader(false);
          return;
        } else {
          navigate(ROUTE_ABANDONED_PAGE);
          setLoader(false);
          return;
        }
      }
      //   history.go(0);
    };

    const onAccountConnectedCallBack = (accountId, workplatformId, userId) => {
      sessionStorage.setItem(STORAGE_CONNECTION_STATE, CONNECTION_SUCCESS);
      sessionStorage.setItem(CONNECTED_STORAGE_WORK_PLATFORM_ID, workplatformId);
      // Retrieve the existing accountIds array from sessionStorage and add new accountID
      let accountIds = JSON.parse(sessionStorage.getItem(CONNECTED_ACCOUNT_ID)) || [];
      accountIds.push(accountId);
      sessionStorage.setItem(CONNECTED_ACCOUNT_ID, JSON.stringify(accountIds));
      console.log(`onAccountConnected accountId: ${accountId}, workplatformId: ${workplatformId}, userId: ${userId}`);
    };
    const onAccountDisconnectedCallBack = (accountId, workplatformId, userId) => {
      console.log(`onAccountDisconnected accountId: ${accountId}, workplatformId: ${workplatformId}, userId: ${userId}`);
    };
    const onTokenExpiredCallBack = (userId) => {
      console.log(`onTokenExpired userId: ${userId}`);
    };

    const onConnectionFailure = (reason, workplatformId, userId) => {
      sessionStorage.setItem(CONNECTED_STORAGE_WORK_PLATFORM_ID, workplatformId);
      // if state not success
      const state = sessionStorage.getItem(STORAGE_CONNECTION_STATE);
      if (state === CONNECTION_SUCCESS) {
        return;
      }
      if (reason === "CONNECTION_ABANDONED") {
        sessionStorage.setItem(STORAGE_CONNECTION_STATE, CONNECTION_ABANDONED);
      } else if (reason === "INCORRECT_ACCOUNT_TYPE" || reason === "INADEQUATE_PERMISSIONS") {
        sessionStorage.setItem(STORAGE_CONNECTION_STATE, CONNECTION_ERROR);
      } else {
        sessionStorage.setItem(STORAGE_CONNECTION_STATE, CONNECTION_ERROR);
      }

      console.log(`onConnectionFailure: ${reason}, ${workplatformId}, ${userId}`);
    };

    const phylloConnect = window.PhylloConnect.initialize(config);

    phylloConnect.on("exit", onExitCallBack);
    phylloConnect.on("tokenExpired", onTokenExpiredCallBack);
    phylloConnect.on("accountConnected", onAccountConnectedCallBack);
    phylloConnect.on("accountDisconnected", onAccountDisconnectedCallBack);
    phylloConnect.on("connectionFailure", onConnectionFailure);

    phylloConnect.open();
  } catch (err) {
    console.log(err);
    setLoader(false);
    throw err;
  }
};

export const isEmpty = (val) => {
  switch (typeof val) {
    case "object":
      if (Object.keys(val).length === 0) return true;
      return false;
    case "string":
      if (val === "") return true;
      return false;
    default:
      if (val !== null && val !== undefined) return false;
      return true;
  }
};
